module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-section",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : '']
  }, [(false) ? _c('div', {
    staticClass: "section-indicator"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'landing') ? _c('div', {
    staticClass: "container-wrapper"
  }, [(_vm.loading === false) ? _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "slick-wrapper",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item-wrapper",
      staticStyle: {
        "background-color": "black"
      },
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : (item.image_mobile) ? _c('div', {
      staticClass: "item-image item-image-mobile",
      style: ({
        'background-image': 'url(' + item.image_mobile.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-slogan"
    }, [_c('div-container', [_c('div', {
      staticClass: "slogan"
    }, [_c('h1', [_vm._v("\n                    Come BBQ\n                  ")]), _c('br'), _vm._v(" "), _c('h1', [_vm._v("\n                    With The Boss\n                  ")])])])], 1)])
  }), 0)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('section', {
    staticClass: "scroll-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$scrollTo('#section-about', {
          offset: -30
        })
      }
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (false) ? _c('section', {
    staticClass: "arrow-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$scrollTo('#section-about', {
          offset: -30
        })
      }
    }
  }, [_c('span')])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674bbc71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopSection.vue
// module id = 922
// module chunks = 1